import * as yup from 'yup';
import { t } from 'i18next';
import { ResponseActionType } from 'generated/index';

const booleanSchema = () =>
  yup.boolean().default(false).required(t('validation.valueIsRequired'));

const numberSchema = () =>
  yup.number().default(0).required(t('validation.valueIsRequired'));

const schema = yup.object().shape({
  round: yup.object().shape({
    minutesBeforeStart: numberSchema(),
    minimalMinutesOfAdvantageBeforeNext: numberSchema(),
    includeOwn: booleanSchema(),
    includeShared: booleanSchema(),
    includePreference1: booleanSchema(),
    includePreference2: booleanSchema(),
    includeFlexWithPreference1: booleanSchema(),
    includeFlexWithPreference2: booleanSchema(),
    includeFlex: booleanSchema(),
    includeDeployableAsFlexWithPreference1: booleanSchema(),
    includeDeployableAsFlexWithPreference2: booleanSchema(),
    includeDeployableAsFlex: booleanSchema(),
    overlapMargin: numberSchema(),
    responseActionType: yup.mixed<ResponseActionType>().default('CONNECT')
  })
});

export default schema;
